export enum OrderStatus {
  COMPLETED = 'COMPLETED',
  FAILEDRECORDED = 'FAILEDRECORDED',
  UNSIGNED = 'UNSIGNED',
}
